export default {
    'original_image': {
        display: {
            name: '數位物件原始檔',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'original_image_name',
            data_type: 'file_url',
        },
        change: {
            editable: false,
            addable: true,
            type: 'multiple-file',
            name: 'do_files',
            required: true
        },
    },
    'preview_picture': {
        display: {
            name: '預覽',
            type: 'image',
        },
        source: {
            type: 'db',
            key: 'preview_image_url_800',
            data_type: 'image_url',
        },
        change: {
            editable: false,
            addable: false,
        }
    },
    'preview_picture_download': {
        display: {
            name: '預覽下載',
            type: 'link',
        },
        source: {
            type: 'db',
            key: 'preview_image_url_150',
            data_type: 'image_url',
        },
        change: {
            editable: false,
            addable: false,
        }
    },
    'digital_type': {
        display: {
            name: '檔案類型',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'digital_type',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'single-select-as-is',
            name: 'digital_type',
            options: {
                type: 'fixed',
                list: [
                    { label: '圖片', value: 'image' },
                    { label: '文件', value: 'doc' },
                    { label: '影片', value: 'video' },
                    { label: '音訊', value: 'audio' },
                ]
            },
            validator: [{ required: true, message: '必填', trigger: 'change' }],
        }
    },
    'carrier_type': {
        display: {
            name: '載體類型',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'carrier_type',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            name: 'carrier_type',
            type: 'single-select-as-is',
            options: {
                type: 'fixed',
                list: ['光碟','磁碟片','硬碟','電腦'].map(x=>({value:x, label:x})),
                additional: true
            }
        }
    },
    'carrier_location': {
        display: {
            name: '載體存放地點',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'carrier_location',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'string',
            name: 'carrier_location'
        }
    },
    'description': {
        display: {
            name: '敘述',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'description',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'string',
            name: 'description'
        }
    },
}
  